'use client'

import Link from 'next/link'

import Container from '@/components/ui/Container'
import Icon from '@/components/ui/icon'
import { CompanyAddress } from '@/types/home.type'

type FooterContactProps = {
  companyAddress: CompanyAddress[]
}

export default function FooterContact({ companyAddress }: FooterContactProps) {
  return (
    <div className="bg-[#131a22] text-[#94a3b8] text-[12.5px]">
      <Container>
        <div className="grid grid-cols-12 py-3">
          {companyAddress.map((address) => (
            <div key={`company_address-${address.id}`} className="col-span-5">
              <h2 className="uppercase font-semibold text-[13px]">{address.name}</h2>
              <Link href="/lien-he" className="flex justify-start gap-0.5 hover:text-primary duration-100 text-[13px]">
                <Icon icon="tgic icon-map-marker" className="text-xs" />
                {address.address}
              </Link>
              <div className="flex justify-start gap-1 duration-100 text-[13px] mt-1">
                <Icon icon="tgic icon-phone" className="text-[10px]" />
                {address.phone} - {address.mobile}
              </div>
              <div className="flex justify-start gap-1 duration-100 text-[13px] mt-1">
                <Icon icon="tgic icon-envelope-solid" className="text-[11px]" />
                {address.email}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
